import React from 'react';
import { useRouter } from '@tribeplatform/react-sdk';
import { Alert } from '@tribeplatform/react-ui-kit/Alert';
export const AnnouncementBannerBlock = ({ title, url, style = 'primary', rounded = true, }) => {
    const { Link } = useRouter();
    if (!title) {
        return null;
    }
    if (url) {
        return (React.createElement(Alert, { title: title, status: style, as: Link, href: url, align: "center", className: !rounded && 'rounded-none' }));
    }
    return (React.createElement(Alert, { title: title, status: style, align: "center", className: !rounded && 'rounded-none' }));
};
//# sourceMappingURL=Block.js.map